import React from 'react';

import AppModal from 'components/modal/appModal';
import { callApi } from 'helpers/callApi/callApi';
import { ArchiveClientModalContentProps } from './ArchiveClientModalContentProps';
import styles from './ArchiveClientModalContent.module.scss';

export const ArchiveClientModalContent = ({
  archiveClient,
  data: { client },
  id,
  close,
  getEvents,
  getArchivedEvents,
}: ArchiveClientModalContentProps) => {
  const handleSubmit = () => {
    callApi({
      action: () => archiveClient(client.id, client.archived),
      onSuccess: () => {
        close();
        getEvents();
        getArchivedEvents();
      },
    });
  };

  return (
    <AppModal
      id={id}
      title="Archive client"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <div className={styles.modalText}>
        {client.archived ? (
          <p>
            Are you sure you want to unarchive <strong>{client.name || 'unnamed'}</strong> client?
          </p>
        ) : (
          <>
            <p>
              Are you sure you want to archive <strong>{client.name}</strong> client?
            </p>
            <p className={styles.modalWarn}>All assigned events will be archived.</p>
          </>
        )}
      </div>
    </AppModal>
  );
};
